import ChangeFeePaymentMethod from './ChangeFeePaymentMethod';

export default ChangeFeePaymentMethod;
